import React from 'react'
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import Gallery from './Gallery';

function GalleryIndex() {
  return (
    <div>
      <Navbar />
      <Gallery />
      <Footer />
    </div>
  )
}

export default GalleryIndex

